<div *ngIf="event || uuid" style="margin-top: 25px;">
  <h4>Historial de alertas sobre el nodo:</h4>
  <!-- <span>{{ (componentMode == 'source' ? event.lastEntrada.topic : ('DATA_TYPE_AND_AGRUPATIONS.'concat(event.es.nombre)) | translate }}</span> -->
  <div class="mat-elevation-z8" style="width: 85%; margin-top: 15px;" align="center" *ngIf="!loading;else spinnerBlock">
    <!--   -->
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef><b>Fecha del evento</b></th>
        <td mat-cell *matCellDef="let d">{{ d.fecha | getDatePipe }}</td>
      </ng-container>

      <ng-container matColumnDef="alarmado">
        <th mat-header-cell *matHeaderCellDef><b>Fecha del evento</b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.properties.alarmado * 1000000 | getDatePipe }}
        </td>
      </ng-container>

      <ng-container matColumnDef="silenciado">
        <th mat-header-cell *matHeaderCellDef><b>Silenciado</b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.properties.silenciado | getDatePipe }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastFecha">
        <th mat-header-cell *matHeaderCellDef>
          <b>Fecha del último dato recibido</b>
        </th>
        <td mat-cell *matCellDef="let d">
          {{ d.properties.lastFecha | getDatePipe }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastValor">
        <th mat-header-cell *matHeaderCellDef>
          <b>Valor del último dato recibido </b>
        </th>
        <td mat-cell *matCellDef="let d">{{ d.properties.lastValor }}</td>
      </ng-container>

      <ng-container matColumnDef="eventType">
        <th mat-header-cell *matHeaderCellDef>
          <b>Tipo de evento</b>
        </th>
        <td mat-cell *matCellDef="let d">{{ 'ALARMAS.FIELD_ALARMS.'.concat(d.type) | translate }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'trSilenciado': ['MONITOR_ALARM_SILENCE_SOURCE', 'MONITOR_ALARM_SILENCE_DATO', 'MONITOR_ALARM_SILENCE_NODELINK'].includes(row.type), 
      'trRearmado' : ['REARMAR_ALARM_SILENCE_DATO', 'REARMAR_ALARM_SILENCE_SOURCE', 'REARMAR_ALARM_SILENCE_NODELINK'].includes(row.type),
      'trAlarmado' : ['MONITOR_ALARM_DELAY'].includes(row.type)}"></tr>
    </table>
    <mat-paginator
      [pageSizeOptions]="[10, 20, 100]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>


<ng-template #spinnerBlock>
    <app-loading [loadingText]="'Cargando datos...'"></app-loading>
</ng-template>
